import { Injectable } from "@angular/core";
import { ActivatedRouteSnapshot, CanActivate, Router, RouterStateSnapshot, UrlTree } from "@angular/router";

import { CookieService } from "ngx-cookie-service";
import { InstanceService } from "../services/instance.service";
import { SessionService } from "../services/session.service";
import { Observable, of } from "rxjs";
import { map } from "rxjs/operators";

@Injectable()
export class SuperOpsGuard implements CanActivate  {
    constructor(
        private cookieService: CookieService,
        private sessionService: SessionService,
        private instanceService: InstanceService,
        private router: Router
    ) {}

    canActivate(): Observable<boolean | UrlTree> {

        if (!this.cookieService.check("app-center-sessionId")) return of(this.redirectToLogin());

        return this.sessionService.session$
            .pipe(
                map(session => {
                    if (session.hasSuperOps || session.hasSuperAdmin) {
                        return true;
                    } else {
                        return this.router.parseUrl('superops-required')
                    }
                })
            )
    }

    // Redirect to app center login
    // Not testable because it uses window.location
    redirectToLogin(): boolean {
        window.location.href = this.instanceService.appCenterUrl;
        return false;
    }


}
